import { IFlowModelTagSummary } from '@Shared.Angular/@types/core/contracts/queryModel/flowModels/flowModelSummary';
import { Guid } from '@Shared.Angular/@types/guid';
import { LibraryDisplayTypes } from '@Shared.Angular/flowingly.services/flowingly.constants';

/**
 * @ngdoc directive
 * @name runner.library.tabs.drafts
 * @module flowingly.runner.library
 * @description This component is the drafts tab of Library component
 * @usage
 */
angular.module('flowingly.runner.library').component('flowLibraryTabsDrafts', {
  bindings: {
    flowModels: '<',
    flowModelTags: '<'
  },
  templateUrl:
    'Client/runner.library/runner.library.draft/runner.library.tabs.drafts.tmpl.html',
  controller: [
    'APP_CONFIG',
    function (APP_CONFIG) {
      const $ctrl = this as {
        flowModelTags: IFlowModelTagSummary[];
        tagsUsed: Guid[];
        [key: string]: unknown;
      };
      $ctrl.APP_CONFIG = APP_CONFIG;
      $ctrl.tagsUsed = [];

      $ctrl.$onInit = function () {
        $ctrl.draftDisplayType = LibraryDisplayTypes.DRAFT;
      };

      $ctrl.$onChanges = function () {
        if (APP_CONFIG.enableTagging) {
          setTagsUsed();
        }
      };

      function setTagsUsed() {
        $ctrl.tagsUsed = $ctrl.flowModelTags
          ?.filter((tagGroup) => tagGroup.publishType === null)
          .flatMap((tagGroup) => tagGroup.tags ?? []);
      }

      $ctrl.onTagFilterChange = (selectedTagIds = []) => {
        $ctrl.selectedTagIds = selectedTagIds;
      };
    }
  ]
});
